import {AppRouteUrl} from "@pinch-financial/pinch-ui-components";
import {useEffect} from "react";
import {useAuth} from "react-oidc-context";
import {useDispatch} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";
import {authorizationCodeCallback} from "store/actions/auth.action";
import LoadingPage from "~/pages/LoadingPage/LoadingPage";
import {migrateUser} from "~/api/auth";

const AuthorizationCodeCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useAuth();
  const [searchParams, _setSearchParams] = useSearchParams();
  const email = searchParams.get("migrateEmail");

  useEffect(() => {
    const handleAuth = async () => {
      if (window._env_.REACT_APP_AUTHENTICATION_METHOD.toUpperCase() === "KEYCLOAK") {
        if (email) {
          const response = await migrateUser(email);
          if (response.error) {
            console.error("Migration failed:", response.error);
          }
          navigate(AppRouteUrl.SIGN_IN);
        }
      } else {
        dispatch(authorizationCodeCallback({navigate}));
      }
    };
    handleAuth();
  }, [auth]);

  return <LoadingPage />;
};

export default AuthorizationCodeCallback;
